import React from 'react';

export const Remove = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.19857 9.59552C6.97755 9.59552 6.76559 9.68332 6.60931 9.8396C6.45303 9.99588 6.36523 10.2078 6.36523 10.4289C6.36523 10.6499 6.45303 10.8618 6.60931 11.0181C6.76559 11.1744 6.97755 11.2622 7.19857 11.2622H13.8652C14.0862 11.2622 14.2982 11.1744 14.4545 11.0181C14.6108 10.8618 14.6986 10.6499 14.6986 10.4289C14.6986 10.2078 14.6108 9.99588 14.4545 9.8396C14.2982 9.68332 14.0862 9.59552 13.8652 9.59552H7.19857Z"
      fill="#6E6B8C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6986 10.4289C19.6986 15.4914 15.5944 19.5955 10.5319 19.5955C5.4694 19.5955 1.36523 15.4914 1.36523 10.4289C1.36523 5.36637 5.4694 1.26221 10.5319 1.26221C15.5944 1.26221 19.6986 5.36637 19.6986 10.4289ZM18.0319 10.4289C18.0319 11.4138 17.8379 12.3891 17.461 13.299C17.0841 14.2089 16.5316 15.0357 15.8352 15.7322C15.1388 16.4286 14.312 16.9811 13.402 17.358C12.4921 17.7349 11.5168 17.9289 10.5319 17.9289C9.54699 17.9289 8.57172 17.7349 7.66178 17.358C6.75183 16.9811 5.92504 16.4286 5.2286 15.7322C4.53216 15.0357 3.97972 14.2089 3.6028 13.299C3.22589 12.3891 3.0319 11.4138 3.0319 10.4289C3.0319 8.43975 3.82208 6.5321 5.2286 5.12557C6.63512 3.71905 8.54278 2.92887 10.5319 2.92887C12.521 2.92887 14.4287 3.71905 15.8352 5.12557C17.2417 6.5321 18.0319 8.43975 18.0319 10.4289Z"
      fill="#6E6B8C"
    />
  </svg>
);
